/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserRole } from '@shared/models';
import { NgxPermissionsService } from 'ngx-permissions';
import { from, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class WriteAccessGuard {

  constructor(
    private permissionsService: NgxPermissionsService,
    private router: Router
  ) { }

  canActivate(): Observable<boolean> {
    return from(this.permissionsService.hasPermission(UserRole.User)).pipe(
      tap((canWrite: boolean) => {
        if (false === canWrite) {
          this.router.navigate(['/tours']);
        }
      })
    );
  }
}
